import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    padding: 4px 8px;\n    margin: -8px -8px 0 0;\n    border-radius: 0px 4px;\n\n    font-family: ", ";\n    font-size: 12px;\n    font-weight: ", ";\n\n    max-width: ", ";\n    ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    float: right;\n    padding: 8px;\n\n    margin-top: -12px;\n    margin-right: -12px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { Text } from '../../Atoms';
export var StyledThemeLight = function StyledThemeLight(props) {
  return "\n    background: ".concat(props.theme.global.colors.white, ";\n    color: ").concat(props.theme.global.colors.capeCode, ";\n\n    ").concat(Text.Styles.StyledText, " {\n        color: ").concat(props.theme.global.colors.capeCode, ";\n    }\n");
};
export var StyledThemeDark = function StyledThemeDark(props) {
  return "\n    background: ".concat(props.theme.global.colors.cyprus, ";\n    color: ").concat(props.theme.global.colors.white, ";\n\n    ").concat(Text.Styles.StyledText, " {\n        color: ").concat(props.theme.global.colors.white, ";\n    }\n");
};
export var StyledCard = styled.div(_templateObject(), function (props) {
  return "\n        position: relative;\n        padding: ".concat(props.hasColor ? '18px' : '12px', " 12px 32px 12px;\n        width: ").concat(props.width, ";\n        ").concat(props.fullWidth ? 'width: 100%;' : '', "\n        ").concat(props.isClickable ? 'cursor: pointer;' : '', "\n        ").concat(props.shadow ? "box-shadow: ".concat(props.theme.components.newCard.shadow, ";") : '', "\n        max-width: 100%;\n        border-radius: 5px;\n        border: 1px solid ").concat(props.theme.global.colors.porcelainDarker, ";\n        box-sizing: border-box;\n\n        ").concat(props.dark ? StyledThemeDark(props) : StyledThemeLight(props), "\n    ");
});
export var StyledCardColor = styled.div(_templateObject2(), function (props) {
  return "\n        background-color: ".concat(props.color, ";\n        border-radius: 4px 4px 0px 0px;\n        width: 100%;\n        height: 6px;\n        position: absolute;\n        top: 0;\n        left: 0;\n    ");
});
export var StyledUpperTagWrapper = styled.div(_templateObject3());
export var StyledUpperTag = styled.div(_templateObject4(), function (props) {
  return props.theme.global.typographyConfig.body.fontFamily;
}, function (props) {
  return props.theme.global.fontWeights.regular;
}, function (props) {
  return props.upperTagWidth;
}, function (props) {
  return props.dark ? StyledThemeLight(props) : StyledThemeDark(props);
});
export var StyledTitleWrapper = styled.div(_templateObject5(), function (props) {
  return "\n        margin: 0;\n        font-family: ".concat(props.theme.global.typographyConfig.headings.fontFamily, ";\n        font-size: 18px;\n        font-weight: ").concat(props.theme.global.fontWeights.semiBold, ";\n        color: ").concat(props.theme.global.typographyConfig.headings.color, ";\n    ");
});
export var StyledBottom = styled.div(_templateObject6(), function (props) {
  return "\n        color: ".concat(props.theme.global.colors.primary, ";\n        font-family: ").concat(props.theme.global.typographyConfig.body.fontFamily, ";\n        font-size: ").concat(props.theme.global.typographyConfig.body.small.fontSize, ";\n        font-weight: ").concat(props.theme.global.fontWeights.semiBold, ";\n        line-height: ").concat(props.theme.global.typographyConfig.body.small.lineHeight, ";\n        position: absolute;\n        bottom: 5px;\n        right: 12px;\n        text-transform: uppercase;\n    ");
});